import { StateCreator } from "zustand";

import { IProjectFilter, IProjectSlice } from "../models";
import { sliceResetFns } from "store";

const initialState = {
  showArchived: false,
  stage: "",
  filters: {
    projectStatus: [],
    subcontractor: [],
    utilityProgram: [],
    accountManager: [],
    auditor: [],
    customerPaymentMethod: [],
  },
};

export const createProjectSlice: StateCreator<
  IProjectSlice,
  [["zustand/devtools", never]],
  [],
  IProjectSlice
> = (set) => {
  sliceResetFns.add(() => set(initialState));
  return {
    ...initialState,
    setShowArchived: (showArchived: boolean) =>
      set((state) => ({
        showArchived,
      })),
    setStage: (stage: string) =>
      set((state) => ({
        stage: stage,
      })),
    setFilters: (data: IProjectFilter) =>
      set((state) => ({
        filters: data,
      })),
    clearFilters: () =>
      set((state) => ({
        filters: {
          projectStatus: [],
          subcontractor: [],
          utilityProgram: [],
          accountManager: [],
          auditor: [],
          customerPaymentMethod: [],
        },
      })),
    resetProjectSlice: () => set(() => initialState),
  };
};
